import createUserMediaRecorderLogger from "./user-media";
import createDisplayRecorderLogger from "./display";
export default function createRecorderLogger(baseLog) {
    const log = (input) => baseLog({ ...input, type: `recorder:${input.type}` });
    return {
        userMedia: createUserMediaRecorderLogger(log),
        display: createDisplayRecorderLogger(log),
    };
}
